import {createReducer, on} from '@ngrx/store';
import {EntityState, EntityAdapter, createEntityAdapter} from '@ngrx/entity';
import * as EntryActions from '../_actions/entry-entity.actions';
import {IEntryForShow} from '../_interface/ientry-for-show';

export const featureKey = 'entryEntities';

export interface State extends EntityState<IEntryForShow> {
	loaded: boolean;
}

export const adapter: EntityAdapter<IEntryForShow> = createEntityAdapter<IEntryForShow>(
	{selectId: model => model.entryId}
);

export const initialState: State = adapter.getInitialState({loaded: false});


export const reducer = createReducer(
	initialState,
	on(EntryActions.loadEntries,
	(state, action) => {
		return adapter.setAll(action.entries, {...state, loaded: true});
	}),
	on(EntryActions.clearEntries,
		state => adapter.removeAll({...state, loaded: false})
	),
	on(EntryActions.upsertOne,
		(state, {entry}) => adapter.upsertOne(entry, state)
	)
);
